/**
 * @file   书画
 * @create macaiqi 2025/05/08
 * @update 
 */
import React, { useRef, useEffect } from 'react';
import cls from 'classnames';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.min.css';
import './qnqs.scss'
export default function SH({ listdata }) {
    // viewer实例
    const viewerRef = useRef(null);
    // 预览图片
    const viewRef = useRef(null);
    useEffect(() => {
        if (viewRef.current) {
            viewerRef.current = new Viewer(viewRef.current, {
                title: false,
            });
        }
        return () => {
            viewerRef?.current?.destroy()
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewRef.current]);
    return (
        <div className={cls("content", `shcontent`)} >
            <div className='sh'>
                <img src={window.ENV_IMG_PREURL + listdata?.[0]?.imgSrc} alt="" />
                <i className='fangda' onClick={() => {
                    viewerRef.current?.view(0);
                }} />
            </div>
            <div className="shtitle">{listdata?.[0]?.title}
                {listdata?.[0]?.subTitle && <div className="shsubtitle">{listdata?.[0]?.subTitle}</div>}
            </div>
            <div ref={viewRef} style={{ display: 'none' }}>
                <img src={window.ENV_IMG_PREURL + listdata?.[0]?.imgSrc} alt="" />
            </div>
        </div>
    )
}
